/**
 * Generated by orval 🍺
 * Do not edit manually.
 * Bookora API
 * API for **bookora.net** — multi-tenant SaaS for Iranian beauty clinics and
 * aesthetic doctors.
 *
 * ## Conventions
 *
 * - **Versioning**: customer-facing routes live under `/api/v1/...`. The health
 *   probes (`/health`, `/ready`) are unprefixed and version-neutral.
 * - **Response envelope**: every successful JSON response is
 *   `{ "data": <payload>, "meta"?: <extra> }`.
 * - **Error envelope**: every error response is
 *   `{ "statusCode": number, "code": string, "message": string, "details"?: any, "requestId"?: string }`.
 *   `code` is a stable token from `ErrorCode`; `message` is finished Persian copy.
 * - **Pagination**: list endpoints take 1-indexed `?page=&pageSize=` and return
 *   `{ items, page, pageSize, total, pageCount }` inside `data`.
 * - **Auth**: bearer JWT. Tokens come from `/api/v1/auth/otp/verify` and rotate on
 *   `/api/v1/auth/refresh`. There are no passwords in this product.
 * - **Tenancy**: the access token carries the clinic. Every tenant-scoped query is
 *   filtered by it server-side; a `clinicId` in a path or body must agree with the
 *   token or the request is rejected.
 * - **Currency**: every money field is an integer in **rials**. Panels display
 *   toman (1 toman = 10 rials).
 * - **Quantities**: integer milli-units (`…Milli`, 1 unit = 1000).
 *   **Percentages**: basis points (`…PercentBp`, 1% = 100).
 * - **Timestamps**: UTC ISO-8601. Jalali conversion happens in the UI.
 * OpenAPI spec version: 0.1.0
 */
import {
  useMutation,
  useQuery
} from '@tanstack/react-query';
import type {
  DataTag,
  DefinedInitialDataOptions,
  DefinedUseQueryResult,
  MutationFunction,
  QueryClient,
  QueryFunction,
  QueryKey,
  UndefinedInitialDataOptions,
  UseMutationOptions,
  UseMutationResult,
  UseQueryOptions,
  UseQueryResult
} from '@tanstack/react-query';

import type {
  CreateMaterialDto,
  MaterialAlertSettingsDto,
  MaterialListResponse,
  MaterialResponse,
  MaterialsListParams,
  MaterialsRemove200,
  UpdateMaterialDto
} from '../model';

import { apiClient } from '../../mutator';




const withQueryKey = <T extends object, K>(query: T, queryKey: K): T & { queryKey: K } => {
  const result = { queryKey } as T & { queryKey: K };
  for (const key of Object.keys(query)) {
    // The explicit queryKey always wins, matching the previous
    // `{ ...query, queryKey }` spread where it was set last.
    if (key === 'queryKey') continue;
    Object.defineProperty(result, key, {
      enumerable: true,
      configurable: true,
      get: () => (query as Record<string, unknown>)[key],
    });
  }
  return result;
};

/**
 * مقدارها به **میلی‌واحد** (۱ واحد = ۱۰۰۰) و مبالغ به **ریال** برمی‌گردند. فیلد defaultUnitCostRials فقط با دسترسی inventory.view_costs در پاسخ وجود دارد.
 * @summary فهرست کالاها (کاتالوگ سراسری + کالاهای اختصاصی کلینیک)
 */
export const materialsList = (
    params?: MaterialsListParams,
 signal?: AbortSignal
) => {


      return apiClient<MaterialListResponse>(
      {url: `/api/v1/materials`, method: 'GET',
        params, signal
    },
      );
    }




export const getMaterialsListQueryKey = (params?: MaterialsListParams,) => {
    return [
    `/api/v1/materials`, ...(params ? [params] : [])
    ] as const;
    }


export const getMaterialsListQueryOptions = <TData = Awaited<ReturnType<typeof materialsList>>, TError = void>(params?: MaterialsListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof materialsList>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getMaterialsListQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof materialsList>>> = ({ signal }) => materialsList(params, signal);





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof materialsList>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type MaterialsListQueryResult = NonNullable<Awaited<ReturnType<typeof materialsList>>>
export type MaterialsListQueryError = void


export function useMaterialsList<TData = Awaited<ReturnType<typeof materialsList>>, TError = void>(
 params: undefined |  MaterialsListParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof materialsList>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof materialsList>>,
          TError,
          Awaited<ReturnType<typeof materialsList>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useMaterialsList<TData = Awaited<ReturnType<typeof materialsList>>, TError = void>(
 params?: MaterialsListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof materialsList>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof materialsList>>,
          TError,
          Awaited<ReturnType<typeof materialsList>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useMaterialsList<TData = Awaited<ReturnType<typeof materialsList>>, TError = void>(
 params?: MaterialsListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof materialsList>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary فهرست کالاها (کاتالوگ سراسری + کالاهای اختصاصی کلینیک)
 */

export function useMaterialsList<TData = Awaited<ReturnType<typeof materialsList>>, TError = void>(
 params?: MaterialsListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof materialsList>>, TError, TData>>, }
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getMaterialsListQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






/**
 * unitsPerPackageMilli یعنی «چند واحد در یک بسته»؛ ویال بوتاکس ۱۰۰ واحدی می‌شود ۱۰۰۰۰۰.
 * @summary افزودن کالای اختصاصی به فهرست کلینیک
 */
export const materialsCreate = (
    createMaterialDto: CreateMaterialDto,
 signal?: AbortSignal
) => {


      return apiClient<MaterialResponse>(
      {url: `/api/v1/materials`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: createMaterialDto, signal
    },
      );
    }




export const getMaterialsCreateMutationKey = () => ['materialsCreate'] as const;

export const getMaterialsCreateMutationOptions = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof materialsCreate>>, TError,MaterialsCreateMutationVariables, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof materialsCreate>>, TError,MaterialsCreateMutationVariables, TContext> => {

const mutationKey = getMaterialsCreateMutationKey();
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof materialsCreate>>, MaterialsCreateMutationVariables> = (props) => {
          const {data} = props ?? {};

          return  materialsCreate(data,)
        }






  return  { mutationFn, ...mutationOptions }}

    export type MaterialsCreateMutationResult = NonNullable<Awaited<ReturnType<typeof materialsCreate>>>
    export type MaterialsCreateMutationBody = CreateMaterialDto
    export type MaterialsCreateMutationError = void
    export type MaterialsCreateMutationVariables = {data: CreateMaterialDto}

    /**
 * @summary افزودن کالای اختصاصی به فهرست کلینیک
 */
export const useMaterialsCreate = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof materialsCreate>>, TError,MaterialsCreateMutationVariables, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof materialsCreate>>,
        TError,
        MaterialsCreateMutationVariables,
        TContext
      > => {
      return useMutation(getMaterialsCreateMutationOptions(options), queryClient);
    }
    /**
 * @summary جزئیات یک کالا
 */
export const materialsGetById = (
    id: string,
 signal?: AbortSignal
) => {


      return apiClient<MaterialResponse>(
      {url: `/api/v1/materials/${id}`, method: 'GET', signal
    },
      );
    }




export const getMaterialsGetByIdQueryKey = (id: string,) => {
    return [
    `/api/v1/materials/${id}`
    ] as const;
    }


export const getMaterialsGetByIdQueryOptions = <TData = Awaited<ReturnType<typeof materialsGetById>>, TError = void>(id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof materialsGetById>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getMaterialsGetByIdQueryKey(id);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof materialsGetById>>> = ({ signal }) => materialsGetById(id, signal);





   return  { queryKey, queryFn, enabled: id !== null && id !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof materialsGetById>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type MaterialsGetByIdQueryResult = NonNullable<Awaited<ReturnType<typeof materialsGetById>>>
export type MaterialsGetByIdQueryError = void


export function useMaterialsGetById<TData = Awaited<ReturnType<typeof materialsGetById>>, TError = void>(
 id: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof materialsGetById>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof materialsGetById>>,
          TError,
          Awaited<ReturnType<typeof materialsGetById>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useMaterialsGetById<TData = Awaited<ReturnType<typeof materialsGetById>>, TError = void>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof materialsGetById>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof materialsGetById>>,
          TError,
          Awaited<ReturnType<typeof materialsGetById>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useMaterialsGetById<TData = Awaited<ReturnType<typeof materialsGetById>>, TError = void>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof materialsGetById>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary جزئیات یک کالا
 */

export function useMaterialsGetById<TData = Awaited<ReturnType<typeof materialsGetById>>, TError = void>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof materialsGetById>>, TError, TData>>, }
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getMaterialsGetByIdQueryOptions(id,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






/**
 * واحد و اندازهٔ بسته پس از ثبت اولین بچ قابل تغییر نیستند؛ همهٔ مقادیر ثبت‌شده بر همان مبنا ذخیره شده‌اند.
 * @summary ویرایش کالا
 */
export const materialsUpdate = (
    id: string,
    updateMaterialDto: UpdateMaterialDto,
 signal?: AbortSignal
) => {


      return apiClient<MaterialResponse>(
      {url: `/api/v1/materials/${id}`, method: 'PATCH',
      headers: {'Content-Type': 'application/json', },
      data: updateMaterialDto, signal
    },
      );
    }




export const getMaterialsUpdateMutationKey = () => ['materialsUpdate'] as const;

export const getMaterialsUpdateMutationOptions = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof materialsUpdate>>, TError,MaterialsUpdateMutationVariables, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof materialsUpdate>>, TError,MaterialsUpdateMutationVariables, TContext> => {

const mutationKey = getMaterialsUpdateMutationKey();
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof materialsUpdate>>, MaterialsUpdateMutationVariables> = (props) => {
          const {id,data} = props ?? {};

          return  materialsUpdate(id,data,)
        }






  return  { mutationFn, ...mutationOptions }}

    export type MaterialsUpdateMutationResult = NonNullable<Awaited<ReturnType<typeof materialsUpdate>>>
    export type MaterialsUpdateMutationBody = UpdateMaterialDto
    export type MaterialsUpdateMutationError = void
    export type MaterialsUpdateMutationVariables = {id: string;data: UpdateMaterialDto}

    /**
 * @summary ویرایش کالا
 */
export const useMaterialsUpdate = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof materialsUpdate>>, TError,MaterialsUpdateMutationVariables, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof materialsUpdate>>,
        TError,
        MaterialsUpdateMutationVariables,
        TContext
      > => {
      return useMutation(getMaterialsUpdateMutationOptions(options), queryClient);
    }
    /**
 * کالایی که بچ ثبت‌شده دارد حذف نمی‌شود بلکه غیرفعال می‌شود تا تاریخچهٔ مصرف و بهای تمام‌شده سالم بماند. پاسخ می‌گوید کدام اتفاق افتاده است.
 * @summary حذف یا غیرفعال‌سازی کالا
 */
export const materialsRemove = (
    id: string,
 signal?: AbortSignal
) => {


      return apiClient<MaterialsRemove200>(
      {url: `/api/v1/materials/${id}`, method: 'DELETE', signal
    },
      );
    }




export const getMaterialsRemoveMutationKey = () => ['materialsRemove'] as const;

export const getMaterialsRemoveMutationOptions = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof materialsRemove>>, TError,MaterialsRemoveMutationVariables, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof materialsRemove>>, TError,MaterialsRemoveMutationVariables, TContext> => {

const mutationKey = getMaterialsRemoveMutationKey();
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof materialsRemove>>, MaterialsRemoveMutationVariables> = (props) => {
          const {id} = props ?? {};

          return  materialsRemove(id,)
        }






  return  { mutationFn, ...mutationOptions }}

    export type MaterialsRemoveMutationResult = NonNullable<Awaited<ReturnType<typeof materialsRemove>>>

    export type MaterialsRemoveMutationError = void
    export type MaterialsRemoveMutationVariables = {id: string}

    /**
 * @summary حذف یا غیرفعال‌سازی کالا
 */
export const useMaterialsRemove = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof materialsRemove>>, TError,MaterialsRemoveMutationVariables, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof materialsRemove>>,
        TError,
        MaterialsRemoveMutationVariables,
        TContext
      > => {
      return useMutation(getMaterialsRemoveMutationOptions(options), queryClient);
    }
    /**
 * برای کالای کاتالوگ بوکورا، تنظیم خود کلینیک ذخیره می‌شود و `null` هر فیلد رو به مقدار کاتالوگ برمی‌گردونه. برای کالای خود کلینیک، همان مقادیر روی خود کالا نوشته می‌شود. موجودی، هشدارها، پیامک‌ها و راهنمای هوشمند همه همین مقدار رو می‌خوانند.
 * @summary حد سفارش و هشدار انقضای کلینیک برای یک کالا
 */
export const materialsSetAlertSettings = (
    id: string,
    materialAlertSettingsDto: MaterialAlertSettingsDto,
 signal?: AbortSignal
) => {


      return apiClient<MaterialResponse>(
      {url: `/api/v1/materials/${id}/alert-settings`, method: 'PATCH',
      headers: {'Content-Type': 'application/json', },
      data: materialAlertSettingsDto, signal
    },
      );
    }




export const getMaterialsSetAlertSettingsMutationKey = () => ['materialsSetAlertSettings'] as const;

export const getMaterialsSetAlertSettingsMutationOptions = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof materialsSetAlertSettings>>, TError,MaterialsSetAlertSettingsMutationVariables, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof materialsSetAlertSettings>>, TError,MaterialsSetAlertSettingsMutationVariables, TContext> => {

const mutationKey = getMaterialsSetAlertSettingsMutationKey();
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof materialsSetAlertSettings>>, MaterialsSetAlertSettingsMutationVariables> = (props) => {
          const {id,data} = props ?? {};

          return  materialsSetAlertSettings(id,data,)
        }






  return  { mutationFn, ...mutationOptions }}

    export type MaterialsSetAlertSettingsMutationResult = NonNullable<Awaited<ReturnType<typeof materialsSetAlertSettings>>>
    export type MaterialsSetAlertSettingsMutationBody = MaterialAlertSettingsDto
    export type MaterialsSetAlertSettingsMutationError = void
    export type MaterialsSetAlertSettingsMutationVariables = {id: string;data: MaterialAlertSettingsDto}

    /**
 * @summary حد سفارش و هشدار انقضای کلینیک برای یک کالا
 */
export const useMaterialsSetAlertSettings = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof materialsSetAlertSettings>>, TError,MaterialsSetAlertSettingsMutationVariables, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof materialsSetAlertSettings>>,
        TError,
        MaterialsSetAlertSettingsMutationVariables,
        TContext
      > => {
      return useMutation(getMaterialsSetAlertSettingsMutationOptions(options), queryClient);
    }
